import React, { useContext, useEffect, useMemo, useState } from "react";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import { ReactComponent as Logo1 } from '../../assets/logo-day-mobile.svg';
import HarmixLibrary from "../../components/Harmix/library";
import ActionRecords from "../ActionRecords";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import TrackContext from "../../contexts/track-context";

import SearchIcon from '@mui/icons-material/Search';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

import CopyrightIcon from '@mui/icons-material/Copyright';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';

import PersonIcon from '@mui/icons-material/Person';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import Constants from "../../services/constants";
import FacebookLogo from "../../assets/logo/facebookLogo.png"
import YoutubeLogo from "../../assets/logo/youtube-icon.png"
import InstaLogo from "../../assets/logo/instaLogo.png"

import EqualizerIcon from '@mui/icons-material/Equalizer';

import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';
import GraphicEqOutlinedIcon from '@mui/icons-material/GraphicEqOutlined';
import FlareOutlinedIcon from '@mui/icons-material/FlareOutlined'; 
import ZoomInOutlinedIcon from '@mui/icons-material/ZoomInOutlined';
import LibraryMusicOutlinedIcon from '@mui/icons-material/LibraryMusicOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import QueueMusicIcon from '@material-ui/icons/QueueMusic';

import DashboardIcon from '@mui/icons-material/Dashboard';
import CookieManager from "../../services/CookieManager";

const ICON = {
  Search: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.35-4.35" />
    </svg>
  ),
  Spark: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2l1.2 5.2L18 9l-4.8 1.8L12 16l-1.2-5.2L6 9l4.8-1.8L12 2Z" />
      <path d="M5 14l.7 3L9 18l-3.3 1-1 3-1-3L0 17l3.7-1L5 14Z" />
    </svg>
  ),
  List: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 6h13M8 12h13M8 18h13" />
      <path d="M3 6h.01M3 12h.01M3 18h.01" />
    </svg>
  ),
  Folder: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 7a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
    </svg>
  ),
  Clock: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v6l4 2" />
    </svg>
  ),
  Heart: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 21s-7-4.35-7-10a4.2 4.2 0 0 1 7-2.2A4.2 4.2 0 0 1 19 11c0 5.65-7 10-7 10Z" />
    </svg>
  ),
  Download: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3v11" />
      <path d="M8 11l4 4 4-4" />
      <path d="M5 20h14" />
    </svg>
  ),
  Ticket: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4V9Z" />
      <path d="M12 7v10" />
    </svg>
  ),
  User: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21a8 8 0 1 0-16 0" />
      <circle cx="12" cy="8" r="4" />
    </svg>
  ),
  Help: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9a2.5 2.5 0 1 1 4.2 1.8c-.9.8-1.7 1.3-1.7 2.7" />
      <path d="M12 17h.01" />
    </svg>
  ),
  Plus: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 5v14" />
      <path d="M5 12h14" />
    </svg>
  ),
  Trash: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7h16" />
      <path d="M10 11v7M14 11v7" />
      <path d="M9 7l1-2h4l1 2" />
      <path d="M6 7l1 14h10l1-14" />
    </svg>
  ),
  ChevronDown: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9l6 6 6-6" />
    </svg>
  ),
  Play: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="currentColor">
      <path d="M9 18V6l11 6-11 6Z" />
    </svg>
  ),
  Prev: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 6v12" />
      <path d="M19 7L9 12l10 5V7Z" />
    </svg>
  ),
  Next: (p) => (
    <svg viewBox="0 0 24 24" className={p.className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 6v12" />
      <path d="M5 7l10 5-10 5V7Z" />
    </svg>
  ),
  Logout: (p) => (
    <svg
      viewBox="0 0 24 24"
      className={p.className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Door */}
      <path d="M9 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H9" />
      
      {/* Arrow out */}
      <path d="M16 12H3" />
      <path d="M7 8l-4 4 4 4" />
    </svg>
  )
};

function cx(...a) {
  return a.filter(Boolean).join(" ");
}

function PillIcon({ IconComp }) {
  return (
    <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-slate-50 text-slate-500">
      <IconComp className="h-5 w-5" />
    </span>
  );
}


export default function SideMenu() {
  
  const trackContext = useContext(TrackContext);
  const [userDetails, setUserDetails] = useState(JSON.parse(CookieManager.getCookie("user-data") || "{}"));
  const [selected, setSelected] = useState(1);

  const [links, setLinks] = useState([
    userDetails?.userType === "ADMIN" && { label: "Dashboard", url: "/admin" },
    { label: "Music", icon: ICON.List, url: "/library" },
    { label: "Projects", icon: ICON.Folder, url: "/projects" },
    { label: "Play History", icon: ICON.Clock, url: "/history" },
    { label: "Favorites", icon: ICON.Heart, url: "/favourites" },
    // { label: "Downloads", icon: ICON.Download, url: "/favourites" },
    // { label: "Licenses", icon: ICON.Ticket, url: "/favourites" },
    { label: "SFX", icon: ICON.Spark, url: "/sfx" },
    { label: "Now Out", icon: ICON.Spark, url: "/new-inspiration" },
    { label: "Labels", icon: ICON.List, url: ["/catalogs", "/catalog/albums/"] },
    userDetails?.userType !== "ADMIN" && { label: "Profile", icon: ICON.User, url: "/profile" },
    { label: "Support", icon: ICON.Help, url: "/support" },
    { label: "Sign out", icon: ICON.Logout }
  ]);

  const [bottomLinks, setBottomLinks] = useState([
    // { label: "Profile", icon: ICON.User, url: "/profile" },
    // { label: "Support", icon: ICON.Help, url: "/support" },
    // { label: "Sign out", icon: ICON.Logout }
  ]);

  const history=useHistory();

  const path = window.location.pathname;
  const getPageView = () => {
    if(path?.length > 0){
        switch(true){
            case (path.includes("/favourites")):
                return <ActionRecords />;
            default :
                return <HarmixLibrary />;
        }
    }
  }

  useEffect(() => {
    if(path?.length > 0){
      const tempLinks = links.flatMap(e => {
        if(e?.label?.length > 0){
          e.active = getActiveStatus(path, e?.url);
          return e;
        }else
          return [];
      });
      setLinks([...tempLinks])

      const tempBottomLinks = bottomLinks.map(e => {
          e.active = getActiveStatus(path, e.url);
          return e;
      });
      setBottomLinks([...tempBottomLinks])
    }
  }, [path])

  const getActiveStatus = (path, url) => {
    let status = false;
    if(url?.length > 0 && path?.length > 0){
      if(Array.isArray(url)){
        url.forEach(e => {
          if(path.includes(e)){
            status = true;
          }
        })
      }else{
        status = path.includes(url);
      }
    }
    return status;
  }
  useEffect(() => {

  },[links, bottomLinks])

  const getIcon = (label) => {
    if(label?.length > 0){
      switch(label){
        case "Dashboard" :
          return <DashboardIcon style={{fontSize : "30px"}} />
        case "Music" :
          return <ZoomInOutlinedIcon style={{fontSize : "30px"}} />
        case "Projects" :
          return <AssignmentOutlinedIcon style={{fontSize : "30px"}} />
        case "Play History" :
          return <SubscriptionsOutlinedIcon style={{fontSize : "30px"}} />
        case "Favorites" :
          return <FavoriteBorderIcon style={{fontSize : "30px"}} />
        case "SFX" :
          return <GraphicEqOutlinedIcon style={{fontSize : "30px"}} />
        case "Now Out" :
          return <QueueMusicIcon style={{fontSize : "30px"}} />
        case "Labels" :
          return <LibraryMusicOutlinedIcon style={{fontSize : "30px"}} />
          
        case "Profile" :
          return <PersonIcon style={{fontSize : "30px"}} />
        case "Support" :
          return <ChatBubbleOutlineIcon style={{fontSize : "30px"}} />
        case "Sign out" :
          return <LogoutOutlinedIcon style={{fontSize : "30px"}} />

        
          default :
            return <></>
      }
    }
  }
  return (
    <div className="w-full bg-[#f6f7fb]">
    
      <aside className="bg-[rgbvar((--bg))] shadow-[0_10px_30px_rgba(15,23,42,0.08)]">
        {/* Logo */}
        
        <div className="my-1 flex justify-center">
          <div className="relative h-10 rounded-2xl bg-white">
            <div className="flex items-center flex-shrink-0">
                <div className="rounded-full">
                <a href={process.env.REACT_APP_MARKETING_SITE_URL}>
                  <Logo1 />
                </a>
                </div>
            </div>
          </div>
        </div>

        <div className="space-y-1.5">
          {links.map((item) => (
            <button
              key={item.label}
              type="button"
              className={cx(
                "flex w-full items-center gap-2 rounded-xl px-3 py-3 text-left transition cursor-pointer hover:bg-gray-200",
                item.active
                  ? "bg-pink-50 text-pink-900"
                  : "text-black"
              )}
              onClick={() => {item.url?.length > 0 ? history.push(Array.isArray(item.url) ? item.url[0] : item.url) : trackContext.setShowLogoutPopup(true)}}
              style={{background : item.active ? "#ffd7e8" : "white", color : item.active ? "rgb(var(--pink))" : "black"}}
            >
              {/* <PillIcon IconComp={item.icon} /> */}
              <span className="my-2 ml-2">{getIcon(item.label)}</span>
              <span className="menu-title mr-2" 
                style={{background : item.active ? "#ffd7e8" : "white", color : item.active ? "rgb(var(--pink))" : "black"}}>
                {item.label}
              </span>
            </button>
          ))}
        </div>

        {/* <div className="space-y-2 fixed bottom-2 " style={{position : "absolute"}}> */}
          {/* {bottomLinks.map((item) => (
            
            <button
              key={item.label}
              type="button"
              className={cx(
                "flex w-full items-center gap-2 rounded-xl px-3 py-3 text-left text-sm transition cursor-pointer hover:bg-gray-200",
                item.active
                  ? "bg-pink-50 text-slate-900"
                  : "text-black"
              )}
              onClick={() => {item.url?.length > 0 ? history.push(Array.isArray(item.url) ? item.url[0] : item.url) : trackContext.setShowLogoutPopup(true)}}
              style={{background : item.active ? "#ffd7e8" : "white", color : item.active ? "rgb(var(--pink))" : "black"}}
            >
              <span className="my-2 ml-2">{getIcon(item.label)}</span>
              <span className="menu-title mr-2" 
                style={{background : item.active ? "#ffd7e8" : "white", color : item.active ? "rgb(var(--pink))" : "black"}}>
                {item.label}
              </span>
            </button>
          ))} */}

          {/* <div className="w-full flex justify-center mr-8 space-x-3">
            
            <div className="">
              <a href={Constants.SM_FACEBOOK_LINK} target="_blank">
                <img
                  src={FacebookLogo}
                  alt="logo"
                  className="h-6"
                  title="Facebook"
                />
              </a>
            </div>
            <div className="">
              <a href={Constants.SM_YOUTUBE_LINK} target="_blank">
                <img
                  src={YoutubeLogo}
                  alt="logo"
                  className="h-6"
                  title="Youtube"
                />
              </a>
            </div>
            <div className="">
              <a href={Constants.SM_INSTA_LINK} target="_blank">
                <img
                  src={InstaLogo}
                  alt="logo"
                  className="h-6"
                  title="Instagram"
                />
              </a>
            </div>
          </div> */}
        {/* </div> */}
      </aside>
     
    </div>
  );
}
